import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { CATEGORY_LABELS } from "@/components/result/PartnersBox";

const PLATFORMS = { travelpayouts: "Travelpayouts", cj: "CJ", direct: "Diretto" };
const EMPTY = { name: "", platform: "direct", category: "experiences", destinations: "", url_template: "", description: "", active: true };
const input = "h-11 w-full rounded-xl border border-gray-200 bg-slate-50 px-4 text-sm outline-none focus:border-emerald-500 focus:bg-white";

const Field = ({ label, hint, children }) => (
  <label className="block text-sm font-semibold text-gray-700">
    {label}{children}{hint && <span className="mt-1 block text-xs font-normal text-gray-500">{hint}</span>}
  </label>
);

export const PartnerForm = ({ partner, onClose, onSave }) => {
  const [f, setF] = useState(partner ? { ...partner, destinations: (partner.destinations || []).join(", ") } : EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = { ...f, destinations: f.destinations.split(",").map((d) => d.trim()).filter(Boolean) };
    delete body.id; delete body.created_at; delete body.updated_at;
    await onSave(body).finally(() => setBusy(false));
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="partner-form-dialog" className="max-h-[90dvh] w-[calc(100%-2rem)] max-w-lg overflow-y-auto rounded-3xl p-8">
        <DialogTitle className="font-display text-xl font-semibold">{partner ? "Modifica partner" : "Nuovo partner"}</DialogTitle>
        <form onSubmit={submit} className="mt-2 space-y-4">
          <Field label="Nome"><input data-testid="partner-name-input" required value={f.name} onChange={set("name")} className={`${input} mt-1.5`} /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Piattaforma">
              <select data-testid="partner-platform-select" value={f.platform} onChange={set("platform")} className={`${input} mt-1.5`}>
                {Object.entries(PLATFORMS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </select>
            </Field>
            <Field label="Categoria">
              <select data-testid="partner-category-select" value={f.category} onChange={set("category")} className={`${input} mt-1.5`}>
                {Object.entries(CATEGORY_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </select>
            </Field>
          </div>
          <Field label="Destinazioni supportate" hint="Separate da virgola (es. Portogallo, Lisbona). Vuoto o * = tutte le destinazioni.">
            <input data-testid="partner-destinations-input" value={f.destinations} onChange={set("destinations")} className={`${input} mt-1.5`} />
          </Field>
          <Field label="Link affiliato" hint="Deve iniziare con https://. Puoi usare {citta} {destinazione} {paese} {andata} {ritorno} {adulti} {origine} {arrivo} (codici aeroporto) {andata_ddmm} {ritorno_ddmm}. Se un viaggio non ha uno di questi dati il partner non viene mostrato. Per Travelpayouts puoi inserire il link normale del marchio: viene convertito in automatico.">
            <input data-testid="partner-url-input" required value={f.url_template} onChange={set("url_template")} className={`${input} mt-1.5`} />
          </Field>
          <Field label="Descrizione breve (facoltativa)">
            <input data-testid="partner-description-input" maxLength={200} value={f.description} onChange={set("description")} className={`${input} mt-1.5`} />
          </Field>
          <label className="flex items-center gap-3 text-sm font-semibold text-gray-700">
            <input data-testid="partner-active-checkbox" type="checkbox" checked={f.active} onChange={set("active")} className="h-4 w-4 accent-emerald-600" />Attivo
          </label>
          <button data-testid="partner-save-button" type="submit" disabled={busy}
            className="h-11 w-full rounded-full bg-emerald-600 text-sm font-semibold text-white transition-colors hover:bg-emerald-500 disabled:opacity-60">
            {busy ? "Salvataggio…" : "Salva partner"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export { PLATFORMS };
